module.exports = __webpack_public_path__ + "static/media/reset-controls.84ea6dd1.svg";